import { CredentialStatus } from './credentialStatus';
import { CustomPersonCredentialStatusDefinition } from './customPersonCredentialStatusDefinition.model';
import { PersonCredentialApplication } from './personCredentialApplication';

export class PersonCredential {
  public id: string;
  /** format YYYY-MM-DD */
  public credentialStartDate: string;
  /** format YYYY-MM-DD */
  public credentialEndDate: string;
  public status: CredentialStatus;
  public credentialDefinitionId: string;
  public credentialName: string;
  public credentialNumber: string;
  public customPersonCredentialStatusDefinition: CustomPersonCredentialStatusDefinition;
  public isActiveStatus: boolean;
  public isRenewalAvailable: boolean;
  public isReinstatementAvailable: boolean;

  constructor(
    id: string,
    credentialStartDate: string,
    credentialEndDate: string,
    status: CredentialStatus,
    credentialDefinitionId: string,
    credentialName: string,
    credentialNumber: string,
    customPersonCredentialStatusDefinition: CustomPersonCredentialStatusDefinition,
    isRenewalAvailable: boolean,
    isReinstatementAvailable: boolean
  ) {
    this.id = id;
    this.credentialStartDate = credentialStartDate;
    this.credentialEndDate = credentialEndDate;
    this.status = status;
    this.credentialDefinitionId = credentialDefinitionId;
    this.credentialName = credentialName;
    this.credentialNumber = credentialNumber;
    this.customPersonCredentialStatusDefinition = customPersonCredentialStatusDefinition;
    this.isActiveStatus = [CredentialStatus.Active, CredentialStatus.ActiveRenewalPeriod].includes(
      status
    );
    this.isRenewalAvailable = isRenewalAvailable;
    this.isReinstatementAvailable = isReinstatementAvailable;
  }

  static parse(obj: any): PersonCredential {
    let credentialStatus =
      typeof obj.status === 'number'
        ? CredentialStatus[obj.status]
        : (obj.status as keyof typeof CredentialStatus);
    return new PersonCredential(
      obj.id,
      obj.credentialStartDate,
      obj.credentialEndDate,
      CredentialStatus[credentialStatus],
      obj.credentialDefinitionId,
      obj.credentialName,
      obj.credentialNumber,
      obj.customPersonCredentialStatusDefinition,
      obj.isRenewalAvailable,
      obj.isReinstatementAvailable
    );
  }
}
